import { render, staticRenderFns } from "./AccountProjectDetails.vue?vue&type=template&id=33787530&"
import script from "./AccountProjectDetails.vue?vue&type=script&lang=js&"
export * from "./AccountProjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports